export enum DoorDirection {
  left = 0,
  right = 1,
}
